import { useContext, createContext, useRef, useMemo, useCallback } from 'react';
import Loader from '../components/global-loading/Loader';
import { TopLoader } from '../components/global-loading/TopLoader';

const LoaderContext = createContext(null);

export function LoaderProvider({ children }: any) {
  const ref = useRef<any>(null);

  const startLoader = useCallback(() => {
    ref.current.start();
  }, [ref]);

  const stopLoader = useCallback(() => {
    ref.current.stop();
  }, [ref]);

  const value: any = useMemo(
    () => ({ ref, startLoader, stopLoader }),
    [ref, startLoader, stopLoader]
  );

  return (
    <LoaderContext.Provider value={value}>
      <TopLoader />
      {children}
      <Loader ref={ref} />
    </LoaderContext.Provider>
  );
}

//export const useLoader = () => useContext(LoaderContext);
export const useLoader = () => {
  const auth: any = useContext(LoaderContext);
  return { ...auth, test: 'test' };
};
